import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import AppMobileMenu from './AppMobileMenu';
import areaHome from './areaHome';

import {
  setEnableClosedSidebar,
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
} from '../Reducers/ThemeOptions';

import { AuthContext } from 'context/AuthContext';

class HeaderLogo extends React.Component {

  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.state = {
      mobile: false,
      activeSecondaryMenuMobile: false,
      openLeft: false,
      openRight: false,
      relativeWidth: false,
      width: 280,
      noTouchOpen: false,
      noTouchClose: false,
    };

    this.toggleEnableClosedSidebar = this.toggleEnableClosedSidebar.bind(this);
  }

  toggleEnableClosedSidebar() {
    let { enableClosedSidebar, setEnableClosedSidebar } = this.props;
    setEnableClosedSidebar(!enableClosedSidebar);
  }

  render() {

    const user = this.context.user;
    const logoUrl = user
      ? process.env.REACT_APP_LOGOS_ROOT + "/" + user.domain + ".png"
      : "";

    // home of the current app area: /organization, /admin, /partner ...
    const home = areaHome(this.props.location.pathname);

    return (
      <Fragment>
        <div className="app-header__logo">
          <Link to={home} className="logo-src" aria-label="Home">
            {/* organization logo over the default one; hidden when the organization has none */}
            <img src={logoUrl} alt=""
              onError={(e) => { e.target.style.display = 'none'; }} />
          </Link>
          <div className="header__pane ml-auto">
            <button type="button" className="console-sidebar-toggle" onClick={this.toggleEnableClosedSidebar}
              aria-label={this.props.t('console_header.toggle_navigation')} aria-expanded={!this.props.enableClosedSidebar}>
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16" /></svg>
            </button>
          </div>
        </div>
        <AppMobileMenu />
      </Fragment>
    )
  }
}


const mapStateToProps = state => ({
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = dispatch => ({
  setEnableClosedSidebar: enable => dispatch(setEnableClosedSidebar(enable)),
  setEnableMobileMenu: enable => dispatch(setEnableMobileMenu(enable)),
  setEnableMobileMenuSmall: enable => dispatch(setEnableMobileMenuSmall(enable)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(HeaderLogo)));
